<template>
  <b-col cols="12">
    <div class="timeline-item">
      <div class="time-post">
        <span class="time">{{ time }}</span>
      </div>
      <div class="infos-post">
        <div class="categories-post">
          <span class="label">
            {{ resource.type || (resource.FollowupType && resource.FollowupType.description) }}
          </span>
        </div>
        <div class="description-post">
          <p v-if="resource.general_type == 'followup' || resource.body">
            {{ resource.content || resource.body }}
          </p>

          <div v-if="resource.files && resource.files.length > 0" class="files-container">
            <div v-for="(file, index) in resource.files" :key="index" class="file-item"
              :style="file.extensionType == '.pdf' ? 'max-width: 200px;' : ''">
              <button v-if="file.extensionType == '.pdf'" @click="onOpenPreviewModal(file)" class="preview-pdf">
                <FileIcon color="#DB3C3C" :extenssion="file.extensionType" />
                <span class="label pdf-label">
                  {{ file.name }}
                </span>
              </button>

              <div v-else-if="isImage(file.extensionType)" class="image-container">
                <img @click="onOpenPreviewModal(file)" :src="file.link" :alt="file.name" class="file-image" />
              </div>

              <div v-else class="other-file">
                <FileIcon color="#666" :extenssion="file.extensionType" />
              </div>

              <div class="file-actions">
                <button v-if="file.urlDownload" @click="downloadItem(file.urlDownload, file.name)">
                  Baixar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="actions-post">
          <button v-if="edit" @click="editItem">editar</button>
          <button v-if="edit" @click="removeItem">excluir</button>
        </div>
      </div>
      <span class="flag" v-if="
        (resource.general_type == 'followup' || resource.body) &&
        !resource.visible_for_parents &&
        edit
      ">
        Não visível para os responsáveis
      </span>
    </div>
    <FilesViewModal :opening="showPreview" @onClose="onClosePreviewModal"
      :type="(currentFile && currentFile.extensionType) || resource.extension_type"
      :path="(currentFile && currentFile.link) || resource.link" />
  </b-col>
</template>

<script>
import FileIcon from "@/components/svg/IconFiles.vue";
import FilesViewModal from "@/components/modals/FilesViewModal.vue";
import moment from "moment-timezone";

export default {
  name: "TimelineItem",
  components: {
    FileIcon,
    FilesViewModal,
  },

  props: {
    itemKey: null,
    resource: {
      type: Object,
      default: () => ({})
    },
    edit: {
      type: Boolean,
      default: true,
    },
    onRemove: {
      type: Function,
      default: null,
    },
    onEdit: {
      type: Function,
      default: null,
    },
  },

  data: () => {
    return {
      showPreview: false,
      currentFile: null,
    };
  },

  computed: {
    time() {
      if (!this.resource || !this.resource.created_at) {
        return '';
      }
      const timePost = moment(this.resource.created_at).format("DD.MM.YY");
      return timePost;
    },
  },

  methods: {
    isImage(extensionType) {
      const imageTypes = [".jpg", ".jpeg", ".png", ".gif"];
      return imageTypes.includes((extensionType || "").toLowerCase());
    },

    removeItem() {
      this.$emit("onRemove", this.resource);
    },

    editItem() {
      this.$emit("onEdit", this.resource);
    },

    downloadItem(url, fileName = null) {
      if (url) {
        const link = document.createElement("a");
        link.href = url;
        if (fileName) {
          link.setAttribute("download", fileName);
        } else {
          link.setAttribute("download", "");
        }
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.$toast.error("Não foi possível baixar o arquivo.");
      }
    },

    onOpenPreviewModal(file = null) {
      this.currentFile = file;
      this.showPreview = true;
    },

    onClosePreviewModal() {
      this.showPreview = false;
      this.currentFile = null;
    },
  },
};
</script>

<style lang="scss">
.timeline-item {
  background-color: #fff;
  border: 1px solid #b3b3b3;
  border-radius: 10px;
  display: flex;
  align-items: flex-startx;
  justify-content: flex-start;
  gap: 16px;
  margin-bottom: 10px;
  padding: 20px 20px 10px 20px;
  box-sizing: border-box;
  position: relative;

  .flag {
    font-size: 12px;
    color: var(--purple);
    border: 1px solid var(--purple);
    position: absolute;
    bottom: 1.7rem;
    right: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    box-sizing: border-box;
    padding: 5px 10px;
    border-radius: 50px;
  }

  .time-post {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 5px;
    margin-right: 20px;

    .time {
      font-size: 16px;
      color: #666;
    }
  }

  .infos-post {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 5px;

    .categories-post {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      span {
        font-size: 16px;
        color: #666;
      }
    }

    .description-post {
      width: 100%;

      p {
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 10px;
      }

      .files-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 15px;
        width: 100%;

        .file-item {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 10px;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          background-color: #fafafa;
          flex: 0 0 calc(30% - 7.5px);
          justify-content: flex-end;

          .image-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 5px;

            .file-image {
              max-width: 300px;
              max-height: 200px;
              border-radius: 8px;
              cursor: pointer;
              object-fit: cover;
            }
          }

          .other-file {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .file-actions {
            display: flex;
            gap: 8px;
            margin-top: 5px;

            button {
              font-size: 16px;
              font-weight: bold;
              padding: 4px 8px;
              color: #b23066;
              background-color: transparent;
              border: 1px solid transparent;
              border-radius: 4px;
              cursor: pointer;
              transition: all 0.3s ease-in-out;

              &:hover {
                border-color: #b23066;
                border: 1px solid #b23066;
              }
            }
          }
        }
      }
    }

    .preview-pdf {
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      background: rgba(219, 60, 60, 0.1);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      border: 1px solid rgba(219, 60, 60, 0.2);
      margin-bottom: 10px;
      padding: 8px 12px;
      border-radius: 10px;
      transition: all 0.3s ease-in-out;
      min-width: 135px;
      width: auto;

      &:hover {
        background: rgba(219, 60, 60, 0.15);
      }

      .label {
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 400 !important;
        line-height: 24px;
        white-space: nowrap;
        flex-shrink: 0;
      }
    }

    .actions-post {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 10px;
      box-sizing: border-box;

      button {
        text-transform: capitalize;
        color: #b23066;
        background-color: transparent;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        border: 1px solid transparent;
        padding: 10px 10px;
        border-radius: 5px;
        transition: all 0.3s ease-in-out;

        &:hover {
          border-color: #b23066;
        }
      }
    }
  }

  .pdf-label {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
}
</style>
